/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CategoriaListComponent } from "./categoria-list/categoria-list.component";
import { editRoute, newRoute } from "../../shared/services/data.service";
import { CategoriaFormComponent } from "./categoria-form/categoria-form.component";

@NgModule({
  imports: [
    RouterModule.forChild([])
  ],
  exports: [
    RouterModule
  ]
})
export class CategoriasRoutingModule {}

export const categoriasRoutes: any[] = [
  {
    path: '',
    component: CategoriaListComponent
  },{
    path: editRoute + '/:id',
    component: CategoriaFormComponent
  },{
    path: newRoute,
    component: CategoriaFormComponent
  }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/categorias/categorias-routing.module.ts
 **/